import { jsx as _jsx } from "react/jsx-runtime";
import {} from 'react';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';
import { DropdownList } from '../../../Components/DropdownList/index.js';
import Icons from '../../../Elements/Icons/index.js';
import { getTestId } from '../helpers.js';
import { ToolbarItem } from '../styled.js';
import { PlaceholdersDropdownItem } from './PlaceholdersDropdownItem.js';
export const PlaceholdersDropdown = ({ placeholders, onPlaceholderClick, disabled, dataTestId }) => {
    const handlePlaceholderClick = useCallbackRef((placeholder) => {
        onPlaceholderClick?.(placeholder);
    });
    return (_jsx(DropdownList, { zIndex: 1000, dataTestId: getTestId('toolbar-placeholders', dataTestId), renderButton: (isShown) => (_jsx(ToolbarItem, { type: 'button', disabled: disabled, "data-testid": getTestId('toolbar-placeholders', dataTestId), children: _jsx(Icons.More, { size: 20, active: isShown }) })), children: placeholders.map((placeholder) => (_jsx(PlaceholdersDropdownItem, { item: placeholder, onClick: handlePlaceholderClick }, placeholder))) }));
};
